module.exports = __webpack_public_path__ + "img/dsci0082.8288bbf1.jpg";